module.exports = __webpack_public_path__ + "static/media/banner.5268ce9d.jpg";